import React, {useCallback} from 'react'
import '../../assets/css/forms.scss';
import IntlTelInput from "react-intl-tel-input";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';

import InputMask from 'react-input-mask';
import { StickyContainer, Sticky } from 'react-sticky';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faTimesCircle} from "@fortawesome/pro-regular-svg-icons";
import Actions from "../../helpers/actions";
import Select from "react-select";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Switch from "react-ios-switch/lib";
import Functions from "../../helpers/functions";
import ContentLoader from "react-content-loader";
import { Checkbox,Radio } from 'pretty-checkbox-react';
import Button from "../../components/button";


const selectStyleMini = {
    option: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        position:'relative',
        zIndex:1005,
        height:30
    }),
}


const selectStyle = {
    option: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        position:'relative',
        zIndex:1005
    }),
}


export default class orderForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId:props.data.pid,
            templates:[],
            templateID:props.data.tid,
            template:{value:"0",label:"Loading..."},
            formAvaliable:false,
            savingForm:false,
            disabled:false,
            aggreementAccepted:false,
            tabIndex:0,
            offerName:props.data.name+" - "+props.data.dyNumber,
            brand:{value:0,label:""},
            customer:{value:0,label:""},
            model:{value:0,label:""},
            type:{value:0,label:""},
            data: {
                groups:[],
                commercialOffer:[]
            },
            inputs:{}
        };
    }
    componentDidMount(){
        this.getTemplate(this.state.templateID);
        this.getTemplates();
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.data["done"] == true && !this.state.formAvaliable){

        }
    }
    async getTemplates(){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI(
                "/orders/templates",
                {id:this.state.orderId}
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){

                var templates = [];
                templates.push({ value: 0, label: "Select template" });


                response.data.forEach((data)=>{
                    templates.push({ value: data[1], label: data[0] });
                });
                this.setState({template:templates[0],templates:templates});
            } else {

            }
        } catch(error) {

        }
    }
    async getTemplate(id){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI(
                "/templates/get",
                {
                    id:id
                }
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                if(true){
                    this.setState({data:response.data},()=>{
                        var inputs = {};
                        this.state.data.groups.forEach((group,i)=>{
                            group.lines.forEach((line,i)=>{
                                line.columns.map((column,j)=>{
                                    inputs["select_"+column.id+"_"+j] = true;
                                });
                            });
                        });
                        this.setState({inputs:inputs,formAvaliable:true});
                    });
                }
            } else {

            }
        } catch(error) {

        }
    }
    async getTemplateWithdata(id){
        this.setState({loading:true});

        this.setState({formAvaliable:false,data:[]});
        try {
            var url = Functions.generateURI(
                "/templates/get/order",
                {
                    id:id,
                    withData:true
                }
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.setState({formAvaliable:true,data:response.data.data},()=>{
                    var inputs = {};
                    this.state.data.groups.forEach((group,i)=>{
                        group.lines.forEach((line,i)=>{
                            line.columns.map((column,j)=>{
                                inputs["select_"+i+"_"+j] = (j == 0?true:false);
                            });
                        });
                    });
                    this.setState({inputs:inputs,formAvaliable:true});
                });
            } else {
                this.setState({formAvaliable:true});
            }
        } catch(error) {

        }
    }
    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = address => {
        this.setState({address:address});
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                console.log('Success', latLng)
                this.setState({
                    center:{lat:latLng.lat,lng:latLng.lng}
                });
                this.map.panTo({lat:latLng.lat,lng:latLng.lng});
            })
            .catch(error => console.error('Error', error));
    }
    renderColumns(columns,target,i){
        return columns.map((data,j)=>{
            var isFilledData = false;
            var options = [];

            var selected = null;
            var value = null;

            if(data.options != null){
                options.push({id:"-1", value: "-1", label: "Cancel selection"});
                data.options.forEach((option)=>{
                    options.push({id:option.id, value: option.optionValue, label: option.optionName});
                    if(data.value != null){
                        if(data.value.value == option.optionValue){
                            selected = {id:option.id, value: option.optionValue, label: option.optionName}
                            isFilledData = true;
                        }
                    }
                });
            }

            var input;
            if(options.length > 1){
                input = <Select
                    styles={selectStyle}
                    value={selected}
                    onChange={(val)=>{
                        var inputs = this.state.inputs;
                        inputs["select_"+i+"_"+(j + 1)] = true;

                        var newData = this.state.data;
                        this.state.data[target].forEach((group,x)=>{
                            group.lines.forEach((line,y)=>{
                                line.columns.map((column,z)=>{
                                    if(data.id == column.id){
                                        newData[target][x].lines[y].columns[z].value = val;
                                    }
                                });
                            });
                        });
                        this.setState({inputs:inputs,data:newData});
                    }}
                    options={options}
                />;
            } else {
                if(data.value != null){
                    isFilledData = true;
                    value = data.value.value;
                }
                input = <input type={"text"} step="any" value={value} className={"textInput"} onChange={(e) => {

                    var inputs = this.state.inputs;
                    inputs["select_"+i+"_"+(j + 1)] = true;

                    var newData = this.state.data;
                    this.state.data[target].forEach((group,x)=>{
                        group.lines.forEach((line,y)=>{
                            line.columns.map((column,z)=>{
                                if(data.id == column.id){
                                    newData[target][x].lines[y].columns[z].value = {value:e.target.value};
                                }
                            });
                        });
                    });

                    this.setState({inputs:inputs,data:newData});
                }} />
            }

            return(
                <div className={"columns small-12 medium-4 col "+(this.state.inputs["select_"+data.id+"_"+j] == true?" active":" passive")}>
                    <div className={"title"+(isFilledData?" filled":"")}>{(data.name != ""?data.name:"")}&nbsp;</div>
                    <div className={"input row collapse"}>
                        <div className={"columns"}>
                            {input}
                        </div>
                        <div className={"columns shrink"}>
                            <div className={"prefix"}>{data.prefix}</div>
                        </div>
                    </div>
                </div>
            );
        });
    }
    renderLines(lines,target){
        return lines.map((data,i)=>{
            var title = null;
            title = data.name;

            var options = [];

            if(typeof data.options !== "undefined"){
                data.options.forEach((option)=>{
                    options.push([
                        { value: option.optionValue, label: option.optionName },
                    ])
                });
            }

            return(
                <div>
                    <div className={"field row collapse"}>
                        <div className={"columns small-12 medium-12"}>
                            <div className={"row title"}>
                                <div className={"columns"}>
                                    {title}
                                </div>
                                <div className={"columns shrink"}>
                                    <div className={"row align-right"}>
                                        <div className={"columns shrink"}>
                                            {(data.active?"Active":"Passive")}
                                        </div>
                                        <div className={"columns shrink"}>
                                            <Switch
                                                checked={(data.active)}
                                                className={"switch small"}
                                                handleColor="white"
                                                offColor="white"
                                                onChange={(checked) => {
                                                    var newData = this.state.data;
                                                    this.state.data[target].forEach((group,x)=>{
                                                        group.lines.forEach((line,y)=>{
                                                            if(data.id == line.id){
                                                                newData[target][x].lines[y].active = (checked?true:false);
                                                            }
                                                        });
                                                    });
                                                    this.setState({data:newData});
                                                }}
                                                onColor="rgb(102, 170, 234)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"row columnList"+(data.active?" active":"")}>
                                {this.renderColumns(data.columns,target,i)}
                                {(target == "groups"?
                                    <div className={"columns small-12 medium-12 col"}>
                                        <div className={"title"}>Açıklama</div>
                                        <div className={"input"}>
                                        <textarea onChange={(e) => {
                                            var newData = this.state.data;
                                            this.state.data[target].forEach((group,x)=>{
                                                group.lines.forEach((line,y)=>{
                                                    if(data.id == line.id){
                                                        newData[target][x].lines[y].comment = e.target.value;
                                                    }
                                                });
                                            });
                                            this.setState({data:newData});
                                        }}>{data.comment}</textarea>
                                        </div>
                                    </div>
                                    :null)}
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    }
    renderTabs(target){
        return target.map((data,i)=>{
            return(
                <Tab >{data.name}</Tab>
            );
        });
    }
    renderForm(target){
        return target.map((data,i)=>{
           return(
               <TabPanel>
                   {this.renderLines(data.lines,"groups")}
               </TabPanel>
           );
        });
    }
    renderFormWrapper(){
        if(this.state.formAvaliable){
            return(
                <Tabs style={{height:(window.innerHeight - 102)+"px"}} selectedIndex={this.state.tabIndex} onSelect={(tabIndex) => {
                    this.setState({ tabIndex },()=>{
                        var contentView = document.getElementById('contentView');
                        contentView.scrollTop = 0;
                    });
                }}>
                    <TabList>
                        {this.renderTabs(this.state.data.groups)}
                    </TabList>
                    <div className={"container"} id={"contentView"}>
                        {this.renderForm(this.state.data.groups)}
                    </div>
                </Tabs>
            )
        } else {
            return(
                <div style={{height:"100%"}}>
                    <ContentLoader
                        height={40}
                    >
                        <rect x="5" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="90" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="180" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="270" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="330" y="5" rx="4" ry="4" width="70" height="8" />
                    </ContentLoader>
                    <ContentLoader
                        height={140}
                    >
                        {this.renderShimmers()}
                    </ContentLoader>
                </div>
            )
        }
    }
    renderShimmers(){
        var shimmers = [{},{},{},{},{},{},{},{},{},{}];
        return shimmers.map((data,i)=>{
            return(
                <rect x="5" y={(i * 16)} rx="4" ry="4" width="395" height="10" />
            );
        })
    }
    render(){
        var thiz = this;
        return (
            <StickyContainer>
                <div id={"requestForm"}>
                    <div className={"header row"}>
                        <div className={"columns shrink"}>
                            <div className={"logo"}>
                                <img src={"/assets/images/exampleCustomer.png"}/>
                            </div>
                        </div>
                        <div className={"columns shrink"}>
                            <div className={"title"}>
                                {this.state.offerName}
                            </div>
                        </div>
                        <div className={"columns"}>

                        </div>
                        <div className={"columns shrink"}>
                            <Select
                                className={"templateSelection"}
                                styles={selectStyleMini}
                                value={this.state.template}
                                onChange={(val)=>{
                                    this.setState({template:val},()=>{
                                        thiz.getTemplateWithdata(this.state.template.value);
                                    });
                                }}
                                options={this.state.templates}
                            />
                        </div>
                        <div className={"columns shrink"}>
                            <FontAwesomeIcon className={"close"} icon={faTimesCircle} size="x2" onClick={()=>{
                                this.setState({formAvaliable:false,savingForm:false},()=>{
                                    Actions.emit("closeSidePanel");
                                })
                            }}/>
                        </div>
                    </div>
                    {this.renderFormWrapper() }
                    <div className={"footer"}>
                        <div className={"row"}>
                            <div className={"columns"}>
                                <Checkbox name="aggreement" color="primary-o" disabled={(this.state.savingForm?true:false)} animation="smooth" value={1}  checked={(this.state.aggreementAccepted?true:false)} onChange={(e) => {
                                    this.setState({aggreementAccepted:!this.state.aggreementAccepted})
                                }}>I have checked all the information and confirm</Checkbox>
                            </div>
                            <div className={"columns shrink"}>
                                <Button buttonTitle={"button.convertWorkOrder"} loadingTitle={"button.creating"} loading={this.state.savingForm} disabled={(!this.state.aggreementAccepted || this.state.disabled?true:false)} onClick={()=>{
                                    this.saveOrder();
                                }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </StickyContainer>
        );
    }
    async saveOrder(){
        if(this.state.aggreementAccepted){
            try {
                this.setState({loading:true,savingForm:true,disabled:true});
                var url = Functions.generateURI("/orders/create",{
                    orderId:this.state.orderId,
                    offerName:this.state.offerName,
                    brand:this.state.brand,
                    customer:this.state.customer,
                    model:this.state.model,
                    type:this.state.type,
                    data:this.state.data,
                    method:"POST"
                });

                var response = await fetch(url.address, url.header);
                response = await response.json();

                if(response.status){
                    this.setState({formAvaliable:false,savingForm:false,disabled:false},()=>{
                        Actions.emit("closeSidePanel");
                    });
                } else {

                }
            } catch(error) {

            }
        }
    }
}

